import AuthService from "./AuthService";
import { SystemService } from "./SystemService";

export class VehiclesService{
    systemService = null;
    authService = null;
    api = null;

    constructor(){
        this.systemService = new SystemService();
        this.authService = new AuthService();

        this.api = this.systemService.getApiAccess();
    }

    getVehicles(search, page, perPage){
        let sessionId = this.authService.getSessionId();
        let vehiclesPromise = new Promise((resolve, reject) => {
            this.api.get(`vehicles`, {
                params: {search, page, perPage},
                headers: { authorization: sessionId }}).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return vehiclesPromise;
    }

    saveVehicle(vehicle){
        let sessionId = this.authService.getSessionId();
        let savePromise = new Promise((resolve, reject) => {
            this.api.post(`vehicles`, vehicle, {headers: { authorization: sessionId }}).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return savePromise;
    }

    deleteVehicle(id){
        let sessionId = this.authService.getSessionId();
        let deletePromise = new Promise((resolve, reject) => {
            this.api.delete(`vehicles/${id}`, {headers: { authorization: sessionId }}).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return deletePromise;
    }

    
}